import React from 'react';

export const ChartSkeleton: React.FC = () => {
  return (
    <div className="premium-chart-card animate-pulse">
      <div className="space-y-4">
        <div className="flex items-center space-x-3">
          <div className="w-10 h-10 bg-gray-700 rounded-lg"></div>
          <div className="flex-1">
            <div className="h-4 bg-gray-700 rounded w-1/3 mb-2"></div>
            <div className="h-3 bg-gray-700 rounded w-2/3"></div>
          </div>
        </div>

        <div className="h-64 bg-gray-700 rounded-lg"></div>

        <div className="grid grid-cols-3 gap-4">
          <div className="h-16 bg-gray-700 rounded"></div>
          <div className="h-16 bg-gray-700 rounded"></div>
          <div className="h-16 bg-gray-700 rounded"></div>
        </div>
      </div>
    </div>
  );
};

export const InsightsSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-4">
      {[1, 2, 3, 4, 5, 6].map((i) => (
        <div key={i} className="premium-chart-card animate-pulse">
          <div className="flex items-start justify-between mb-4">
            <div className="w-12 h-12 bg-gray-700 rounded-lg"></div>
            <div className="w-20 h-4 bg-gray-700 rounded"></div>
          </div>
          <div className="h-4 bg-gray-700 rounded w-2/3 mb-3"></div>
          <div className="h-8 bg-gray-700 rounded w-1/2 mb-3"></div>
          <div className="space-y-2">
            <div className="h-3 bg-gray-700 rounded"></div>
            <div className="h-3 bg-gray-700 rounded w-5/6"></div>
          </div>
        </div>
      ))}
    </div>
  );
};

export const TableSkeleton: React.FC = () => {
  return (
    <div className="premium-chart-card animate-pulse">
      <div className="space-y-3">
        <div className="flex items-center space-x-3 mb-6">
          <div className="w-8 h-8 bg-gray-700 rounded-lg"></div>
          <div className="h-4 bg-gray-700 rounded w-1/4"></div>
        </div>

        <div className="grid grid-cols-6 gap-2 pb-2 border-b border-gray-700">
          {[1, 2, 3, 4, 5, 6].map((i) => (
            <div key={i} className="h-3 bg-gray-700 rounded"></div>
          ))}
        </div>

        {[1, 2, 3, 4, 5].map((row) => (
          <div key={row} className="grid grid-cols-6 gap-2 py-2">
            {[1, 2, 3, 4, 5, 6].map((col) => (
              <div key={col} className="h-6 bg-gray-700 rounded"></div>
            ))}
          </div>
        ))}
      </div>
    </div>
  );
};

export const StatsSkeleton: React.FC = () => {
  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4">
      {[1, 2, 3, 4].map((i) => (
        <div key={i} className="premium-stats-card animate-pulse">
          <div className="w-10 h-10 bg-gray-700 rounded-lg mb-3"></div>
          <div className="h-3 bg-gray-700 rounded w-2/3 mb-2"></div>
          <div className="h-6 bg-gray-700 rounded w-1/2"></div>
        </div>
      ))}
    </div>
  );
};
